import { render, staticRenderFns } from "./BusinessProjectManager.vue?vue&type=template&id=af879d02&scoped=true&"
import script from "./BusinessProjectManager.vue?vue&type=script&lang=js&"
export * from "./BusinessProjectManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af879d02",
  null
  
)

export default component.exports